import { style } from '@angular/animations';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthApiService } from 'src/app/core/service/auth-api.service';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { ResponseData } from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { AuthService } from 'src/app/helper/service/auth.service';

@Component({
  selector: 'app-license-page',
  templateUrl: './license-page.component.html',
  styleUrl: './license-page.component.scss'
})
export class LicensePageComponent implements OnInit {
  userName: any;
  @Output() licensePass: EventEmitter<boolean> = new EventEmitter<boolean>();
  dataloading: boolean=false;
constructor(private auth: AuthService, private _bsModalRef: BsModalRef,private alertService: AlertService,private authApi: AuthApiService){}
renewForm:boolean=false;
  ngOnInit(): void {
    const data:{}=this.auth;
    this.userName=data['userBS']['_value']['fullName']
  }
  openForm(){
    this.renewForm=true; 
  }
  goBack(){
    this.renewForm=false; 

  }
  onsubmit(){
    let a:any=document.getElementById('renewalCode')
    console.log(a.value,'input');
    if(a.value.length!=20){
      this.alertService.showToast('Give Valid Renewal Code','warn');
      a.value=''
      return;
    }
    this.renewForm=false; 
    this.dataloading=true;
    const data:any=a.value
    this.authApi.licencePass({'licence_key':data}).then((res:ResponseData|any)=>{
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        setTimeout(()=>{
          this.dataloading=false;
    
          this.licensePass.emit(false);
        },4000)
    
      
      }
    })
   
  
  }
 
}
